import { createFileRoute } from '@tanstack/react-router';
import { MenusListScreen } from '@/features/menus/MenusListScreen';

export const Route = createFileRoute('/_app/menus/')({
  component: MenusListScreen,
});
